export class ssApiResponse {

    constructor(public Url: string, public Method: string, public Payload: any) {

    }

}
